import React, { useEffect } from 'react';
import lottie from 'lottie-web';
import { Div } from 'components/common/CommonStyled';

function Lottie({ name, data, ...props }) {
  const elmName = `lottie-file-${name}`;

  useEffect(() => {
    const elmWrapper = document.querySelector(`#${elmName}`);
    if (elmWrapper) {
      elmWrapper.innerHTML = '';
      const def = {
        container: elmWrapper,
        animationData: '',
        renderer: 'svg', // "canvas", "html"
        loop: true, // boolean
        autoplay: true, // boolean
      };

      lottie.loadAnimation({ ...def, ...data });
    }
  }, []);

  return <Div id={elmName} m="0 auto" {...props} />;
}

export default Lottie;
